
export default {
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  methods: {
    iconSrc(slug) {
      return `https://s3.us-east-1.amazonaws.com/lole.product.images/collection_icons/${slug}.png`
    },
  },
}
